/**
 * Shared sort comparators. Consolidated from per-service copies (the same
 * pattern that put round2 in utils/money and the date formatters in utils/date).
 */

/** Newest-first by ISO `createdAt`. Missing dates sort last. Generic over any
 *  record carrying an optional `createdAt` string. */
export const byCreatedDesc = <T extends { createdAt?: string }>(a: T, b: T): number =>
  (b.createdAt ?? '').localeCompare(a.createdAt ?? '');
